import { computed, nextTick, ref, toRaw } from 'vue'
import { similarProduct, showOemList } from '@/apis/associated'
import { searchProducts, searchUrl, searchUpload } from '@/apis/search'
import { getCombinationList } from '@/apis/combined'
import { goodsProductList } from '@/apis/usercenter'
import { getProductList } from '@/apis/stock'
import { useRequest } from '@/util/useLoading'
import { searchStockApi } from '@/apis/goods'
import { isJA, isMultiStore } from '@/store'
import { floatingRate, calc } from '@/util/useYan'
import { isUrl } from '@/plugins/utils'
import { COUNTRY } from '@/global'
import { request } from '@/config/request/interceptors'
const productConfigList:any = {
  // 透明购
  transparent: {
    api: searchProducts,
    formatProduct: (v: any) => ({
      ...v,
      id: v.productCode,
      code: v.productCode,
      name: isJA() ? (v?.productTitleJp || v?.productTitle) : v?.productTitle,
      img: v.productMainImg,
      type: 'common',
      price: v.productSellPrice ?? 0,
      PriceJpy: calc(v.productSellPrice ?? 0, v.goodsCountry === COUNTRY.KR ? 'KRW' : 'CNY'),
      productType: 1
    }),
    getParams: (params:any) => {
      const { keyword, langType, productCategoryFrontendId, priceRange } = params
      const arr = priceRange.split(',')
      return {
        keyword,
        langType,
        channel: 2,
        productCategoryFrontendId,
        sellPriceStart: arr[0] ?? '',
        sellPriceEnd: arr[1] ?? ''
      }
    }
  },
  // 市场购
  market: {
    api: searchProducts,
    formatProduct: (v: any) => ({
      ...v,
      id: v.productCode,
      code: v.productCode,
      name: isJA() ? (v?.productTitleJp || v?.productTitle) : v?.productTitle,
      img: v.productMainImg,
      type: 'common',
      price: v.productSellPrice ?? 0,
      PriceJpy: calc(v.productSellPrice ?? 0, v.goodsCountry === COUNTRY.KR ? 'KRW' : 'CNY'),
      productType: 1
    }),
    getParams: (params:any) => {
      const { keyword, langType, productCategoryFrontendId, priceRange } = params
      const arr = priceRange.split(',')
      return {
        keyword,
        langType,
        channel: 1,
        productCategoryFrontendId,
        sellPriceStart: arr[0] ?? '',
        sellPriceEnd: arr[1] ?? ''
      }
    }
  },
  // 库存
  stock: {
    api: getProductList,
    formatProduct: (v: any) => ({
      ...v,
      id: v.productCode,
      code: v.productCode,
      name: isJA() ? (v?.productTitleJp || v?.productTitle) : v?.productTitle,
      img: v.productSkuImg || v.productMainImg,
      type: 'common',
      price: v.productSellPrice ?? v.unitPrice ?? 0,
      PriceJpy: calc(v.productSellPrice ?? v.unitPrice ?? 0, v.goodsCountry === COUNTRY.KR ? 'KRW' : 'CNY'),
      isStock: true
    }),
    getParams: (params:any) => {
      const { keyword, quantity, quantitySymbol, wareHouseType } = params
      return {
        startAvailableQuantity: quantitySymbol === 1 ? quantity : quantitySymbol === 3 ? 0 : quantity,
        productSkuOrName: keyword,
        endAvailableQuantity: quantitySymbol === 1 ? 999999999 : quantitySymbol === 3 ? quantity : quantity,
        wareHouseType
      }
    }
  },
  oem: {
    api: showOemList,
    formatProduct: (v: any) => ({
      ...v,
      id: v.searchSourceOrderNo,
      code: v.searchSourceOrderNo,
      name: v.productName,
      img: v.productImg,
      type: 'oem',
      price: v.biggestprice ?? 0,
      PriceJpy: calc(v.biggestprice ?? 0, v.goodsCountry === COUNTRY.KR ? 'KRW' : 'CNY'),
      productType: 2,
      productCode: v?.searchSourceOrderSkuResp?.[0]?.productSku,
      productSku: v?.searchSourceOrderSkuResp?.[0]?.productSku
    }),
    getParams: (params:any) => {
      const { keyword } = params
      return {
        productName: keyword
      }
    }
  },
  combin: {
    api: getCombinationList,
    formatProduct: (v: any) => ({
      ...v,
      id: v.combinationProductSku,
      code: v.combinationProductSku,
      name: v.combinationProductName,
      img: v.combinationProductMainImg,
      type: 'combination',
      price: v.productSellPrice ?? 0,
      PriceJpy: calc(v.productSellPrice ?? 0, v.goodsCountry === COUNTRY.KR ? 'KRW' : 'CNY'),
      productType: 3,
      productCode: v.combinationProductSku
    }),
    getParams: (params:any) => {
      const { keyword } = params
      return {
        keywordName: keyword
      }
    }
  },
  collect: {
    api: goodsProductList,
    formatProduct: (v: any) => ({
      ...v,
      id: v.productCode,
      code: v.productCode,
      name: isJA() ? (v?.productTitleJp || v?.productTitle) : v?.productTitle,
      img: v.productMainImg,
      type: 'common',
      price: v.productSellPrice ?? 0,
      PriceJpy: calc(v.productSellPrice ?? 0, v.country === COUNTRY.KR ? 'KRW' : 'CNY'),
      productType: 1
    }),
    getParams: (params:any) => {
      const { keyword } = params
      return {
        productTitle: keyword
      }
    }
  },
  // 相似商品
  similar: {
    api: async (params:any) => {
      const { thirdItemCode, url } = params
      const res1 = await searchUpload({ imageUrl: url })
      return similarProduct({
        ...params,
        sourceProductCode: thirdItemCode,
        sourceProductMainImg: url,
        imageId: res1.data
      })
    },
    formatProduct: (v: any) => ({
      ...v,
      id: v.productSameStyleId,
      code: v.productCode,
      name: v.productTitle,
      img: v.productMainImg,
      type: 'common',
      price: v.productSellPrice ?? 0,
      PriceJpy: calc(v.productSellPrice ?? 0, v.goodsCountry === COUNTRY.KR ? 'KRW' : 'CNY')
    }),
    getParams: (params:any) => {
      return params
    }
  },
  japan: {
    api: request.order.foreign.shopProductSkuPage,
    formatProduct: (v: any) => ({
      ...v,
      id: v.productCode || v.productSku,
      code: v.productCode || v.productSku,
      productCode: v.productType === 3 ? v.productSku : v.productCode || v.productSku,
      name: isJA() ? (v?.productTitleJp || v?.productTitle) : v?.productTitle,
      img: v.productMainImg,
      type: 'common',
      price: 0,
      PriceJpy: v.purchasePrice,
      productType: v.productType
    }),
    getParams: (params:any) => {
      const { keyword } = params
      return {
        productSku: keyword,
        chooseFlag: true
      }
    }
  }
}

export const formatProductArr = (formatProduct:any, data: any) => {
  return (data || []).map((t: any) => formatProduct(t))
}

export default (type:any, params: any) => {
  const apiConfig = computed(() => {
    return productConfigList[type.value]
  })
  const loading = ref(false)
  const list: any = ref([])
  const total = ref()
  const pageData = ref({
    pageNum: 1,
    pageSize: 50
  })

  const getList = () => {
    const filter = {
      ...apiConfig.value.getParams(params.value),
      ...toRaw(pageData.value)
    }
    loading.value = true
    console.log('filter', filter, type.value, apiConfig)
    loading.value = true
    // 存在url搜索的情况
    const isUrlSearch = params.value.keyword && isUrl(params.value.keyword) && ['transparent', 'market'].includes(type.value)
    const api = isUrlSearch ? searchUrl : apiConfig.value.api
    api(isUrlSearch ? {
      channelList: isMultiStore() ? [1, 2, 5] : [1, 2],
      detailUrl: params.value.keyword
    } : filter).then((res: any) => {
      if (isUrlSearch) {
        list.value = res.data ? formatProductArr(apiConfig.value.formatProduct, [res.data]) : []
        total.value = res.data ? 1 : 0
        return
      }
      list.value = formatProductArr(apiConfig.value.formatProduct, res.data?.records)
      total.value = res.data.total
    }).finally(() => { loading.value = false })
  }
  const reset = () => {
    pageData.value.pageNum = 1
    total.value = 0
    list.value = []
  }
  return [
    loading,
    pageData,
    list,
    total,
    getList,
    reset
  ]
}
